import * as Cesium from 'cesium';
import React, { useState } from 'react';
import useViewerStore from '../../../store-zustand/viewer';
import TooltipIconButton from "components/TooltipIconButton";
import { cameraReset3D, enableTiltCesium } from '../../../components/MapView/MapUtils';

const ZoomToolbar = () => {
  const { viewer } = useViewerStore();
  const [dimensionswitch, setdimensionswitch] = useState('3D');

  return (
    <TooltipIconButton title="Toggle View" ariaLabel="toggle-view" placement="top" size={50}
      onClick={(e) => {
        if (dimensionswitch === '2D') {
          cameraReset3D(viewer, 0, new Cesium.HeadingPitchRange(0, -Math.PI / 2, viewer.camera.positionCartographic.height / Math.sqrt(2)));
          enableTiltCesium(viewer, false);
          setdimensionswitch('3D');
        } else {
          cameraReset3D(viewer, 0, new Cesium.HeadingPitchRange(0, -Math.PI / 10, viewer.camera.positionCartographic.height * Math.sqrt(2)));
          enableTiltCesium(viewer, true);
          setdimensionswitch('2D');
        }
      }}>
      {dimensionswitch}
    </TooltipIconButton>
  );
}

export default ZoomToolbar;